import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RealWeddingsIcon = ({
  title = 'RealWeddings',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <mask
      id="ad"
      x="13"
      y="19"
      width="67"
      height="70"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m64.642 19.26-48.705 10.7a2.807 2.807 0 0 0-2.134 3.335L25.401 86.09a2.808 2.808 0 0 0 3.334 2.135l48.707-10.702a2.81 2.81 0 0 0 2.134-3.335l-11.6-52.795a2.81 2.81 0 0 0-2.02-2.104 2.772 2.772 0 0 0-1.315-.03Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#ad)">
      <path
        d="m-7.013 85.48 84.343 22.599 23.063-86.073L16.05-.594-7.013 85.48Z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="ac"
      x="19"
      y="25"
      width="54"
      height="51"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m62.509 25.516-42.017 9.23a.97.97 0 0 0-.738 1.153l8.784 39.971s43.918-9.589 43.903-9.648l-8.782-39.97a.969.969 0 0 0-1.15-.736Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#ac)">
      <path
        d="M2.545 75.414 71.537 93.9l18.147-67.726L20.692 7.688 2.545 75.413Z"
        clipRule="evenodd"
        fill="#fff"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="ab"
      x="45"
      y="53"
      width="7"
      height="19"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path d="m45.847 53.246 4.298 17.968.976-.232-4.298-17.97-.976.234Z" fill="#fff" />
    </mask>
    <g mask="url(#ab)">
      <path
        d="m33.94 73.383 21.504 5.762 7.584-28.303-21.504-5.762-7.583 28.303z"
        clipRule="evenodd"
        fill="#003B57"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="aa"
      x="39"
      y="35"
      width="8"
      height="12"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="M42.183 35.23a3.12 3.12 0 0 0-2.309 3.758c.118.488.346.918.649 1.278h-.004l4.268 5.853 1.152-7.123-.002.002a3.118 3.118 0 0 0-3.754-3.768Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#aa)">
      <path
        d="m30.357 48.763 18.878 5.058 5.9-22.02-18.878-5.059-5.9 22.02z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="z"
      x="43"
      y="45"
      width="7"
      height="12"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m43.577 53.053.004-.002a3.112 3.112 0 0 0 0 1.432 3.12 3.12 0 0 0 6.067-1.45c-.119-.5-.354-.94-.666-1.302l.003-.002-4.249-5.827-1.159 7.15Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#z)">
      <path
        d="m34.389 60.22 18.877 5.058 5.9-22.02-18.877-5.059-5.9 22.021z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="y"
      x="44"
      y="41"
      width="12"
      height="7"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="M51.784 41.125a3.123 3.123 0 0 0-1.277.645l-.002-.003-5.85 4.269 7.12 1.15-.001-.002a3.116 3.116 0 0 0 3.768-3.753 3.118 3.118 0 0 0-3.758-2.306Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#y)">
      <path
        d="m36.953 50.48 22.02 5.9 5.058-18.878-22.02-5.9-5.058 18.877z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="x"
      x="33"
      y="44"
      width="12"
      height="7"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m37.717 44.823.003.002a3.118 3.118 0 1 0 .017 6.068 3.09 3.09 0 0 0 1.3-.665l.002.003 5.83-4.248-7.152-1.16Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#x)">
      <path
        d="m25.491 54.511 22.022 5.901 5.058-18.877-22.022-5.9-5.058 18.877z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="w"
      x="44"
      y="36"
      width="9"
      height="11"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="M46.229 37.58c-.26.428-.402.894-.44 1.362l-.001-.001-1.085 7.161 5.828-4.251-.003-.002a3.119 3.119 0 1 0-4.299-4.27Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#w)">
      <path
        d="m36.175 50.33 18.172 4.87 6.07-22.653-18.172-4.87-6.07 22.653z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="v"
      x="37"
      y="45"
      width="8"
      height="11"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m38.965 50.178.003.001a3.117 3.117 0 1 0 4.769 2.862l.002.003 1.08-7.132-5.854 4.266Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#v)">
      <path
        d="m29.106 59.47 18.173 4.87 6.07-22.652-18.174-4.87-6.07 22.652z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="u"
      x="44"
      y="45"
      width="11"
      height="9"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m51.827 47.035.003-.003-7.163-1.082 4.25 5.828.001-.003a3.118 3.118 0 1 0 4.272-4.303 3.14 3.14 0 0 0-1.363-.437Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#u)">
      <path
        d="m35.571 55.592 22.652 6.07 4.869-18.173-22.652-6.07-4.869 18.173z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="t"
      x="34"
      y="38"
      width="11"
      height="9"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="M35.285 40.257a3.115 3.115 0 0 0 2.44 4.725v.001l7.13 1.082-4.267-5.853-.001.003a3.084 3.084 0 0 0-1.83-1.353 3.119 3.119 0 0 0-3.472 1.395Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#t)">
      <path
        d="m26.429 48.525 22.651 6.07 4.87-18.174-22.652-6.07-4.87 18.174z"
        clipRule="evenodd"
        fill="#F87E7E"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="s"
      x="41"
      y="43"
      width="7"
      height="7"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="m43.992 43.26a2.967 2.967 0 0 0-2.193 3.57 2.963 2.963 0 0 0 5.763-1.378 2.966 2.966 0 0 0-3.57-2.193z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#s)">
      <path
        d="m33.35 52.686 17.872 4.79 4.789-17.873-17.872-4.788-4.79 17.871z"
        clipRule="evenodd"
        fill="#FCD6D3"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="r"
      x="49"
      y="55"
      width="10"
      height="11"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path d="M49.729 65.591s8.034.16 8.33-9.976c0 0-9.022 1.174-8.33 9.976Z" fill="#fff" />
    </mask>
    <g mask="url(#r)">
      <path
        d="m41.421 69.873 18.455 4.944 6.307-23.538-18.455-4.945-6.307 23.539z"
        clipRule="evenodd"
        fill="#003B57"
        fillRule="evenodd"
      />
    </g>
    <mask
      id="q"
      x="37"
      y="60"
      width="13"
      height="7"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
    >
      <path
        d="M37.25 60.587c4.848 8.904 11.941 5.126 11.941 5.126-1.363-3.305-3.58-4.775-5.736-5.353-3.169-.849-6.205.227-6.205.227Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#q)">
      <path
        d="m28.556 68.732 24.572 6.584 4.719-17.609-24.573-6.584-4.718 17.61z"
        clipRule="evenodd"
        fill="#003B57"
        fillRule="evenodd"
      />
    </g>
    <path
      d="M77.323 20.64c2.199-1.078 4.735-.145 5.712 2.084l.04.092.49 1.187 1.153-.565c2.168-1.064 4.664-.17 5.67 1.991l.042.092.04.092c.934 2.264-.065 4.967-2.232 6.09l-.09.044L79.5 35.99a.593.593 0 0 1-.802-.268l-.02-.043-3.676-8.904c-.947-2.294.092-5.04 2.321-6.134ZM17.23 11.41c.557-2.384 2.885-3.756 5.229-3.102l.096.028 1.23.372.292-1.25c.55-2.352 2.82-3.719 5.131-3.13l.098.027.096.028c2.344.71 3.804 3.194 3.301 5.582l-.022.098-2.192 9.38a.593.593 0 0 1-.715.45l-.046-.011-9.219-2.792c-2.376-.719-3.844-3.262-3.28-5.68Z"
      clipRule="evenodd"
      fill="#FEBBB9"
      fillRule="evenodd"
    />
    <g filter="url(#p)">
      <ellipse cx="53.966" cy="21.72" rx="17.626" ry="17.627" fill="#fff" />
    </g>
    <path
      d="M41.938 16.719c1.714-3.127 5.515-4.141 8.547-2.308l.124.077 1.578 1.002.9-1.64c1.69-3.083 5.41-4.112 8.42-2.382l.126.074.124.077c3.01 1.912 4.088 5.967 2.449 9.12l-.07.128-6.74 12.3a.864.864 0 0 1-1.179.353l-.06-.035-11.84-7.518c-3.051-1.938-4.116-6.078-2.379-9.248Z"
      clipRule="evenodd"
      fill="#FEBBB9"
      fillRule="evenodd"
    />
    <defs>
      <filter
        id="p"
        x="30.34"
        y=".094"
        width="47.253"
        height="47.254"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_0_2" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_0_2" result="shape" />
      </filter>
    </defs>
  </CreateIconComponent>
);

export default RealWeddingsIcon;
